import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRSelectedDocumentInitiatives = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument?.KeyInitiatives ?? []
)
